import { render, staticRenderFns } from "./MotionScrollBounding.vue?vue&type=template&id=8b8659f8"
import script from "./MotionScrollBounding.vue?vue&type=script&lang=js"
export * from "./MotionScrollBounding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports